import KioskLogo from "./KioskLogo";
import Button from "@/Components/Button/Button";
import { useSetConfirm } from "@/shared/atoms/useConfirm";
import { useSetModal } from "@/shared/atoms/useModal";
import { useCart } from "@/shared/hooks/useCartHook";
import useCategoryQuery from "@/shared/hooks/useCategoryQuery";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { flags } from "../Maps/KioskLanguage";
import useKioskReset from "../Maps/useKioskReset";
import Kiosk from "./Kiosk";
import KioskCat from "./KioskCat";
import { getKioskCategoriesWithProducts } from "./useKioskCategory";

const KioskNav = ({ deliveryMethod }: { deliveryMethod: string }) => {
  const { t, i18n } = useTranslation("");
  const [cart] = useCart();
  const params = useParams<{ categoryId: string }>();
  const categoryId = params?.categoryId;
  const { data } = useCategoryQuery(deliveryMethod);
  const categories = getKioskCategoriesWithProducts(data);
  const history = useHistory();
  const setModal = useSetModal();
  const kioskReset = useKioskReset();
  const setConfirm = useSetConfirm();
  const onBack = () => {
    if (cart.length === 0) {
      history.push("/kiosk");
      return kioskReset();
    }
    setConfirm({
      message: "Weet je het zeker",
      cb: () => {
        history.push("/kiosk");
        kioskReset();
      },
    });
  };

  const onReturn = () => {
    return history.push("/kiosk/deliverymethods");
  };

  const flagSrc = flags[i18n.language as keyof typeof flags]; // Get the flag source if available

  return (
    <Kiosk>
      <div
        className="flex w-[30rem] flex-col text-[--var(--nav_text_color)] bg-[--var(--nav_background_color)] p-8"
        style={{
          minHeight: "0",
          gridArea: "sidebar",
        }}
      >
        <div className="flex justify-center">
          <KioskLogo className="h-auto w-5xl mb-4 bg-transparent"  />
        </div>
        <div className="overflow-y-hidden grow">
          <Swiper loop slidesPerView={"auto"} direction={"vertical"}>
            {categories.map((category) => (
              <SwiperSlide className="kiosk_slide" key={category.item_id}>
                <KioskCat
                  deliveryMethod={deliveryMethod}
                  isSelected={category.item_id == parseInt(categoryId)}
                  category={category}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex flex-col gap-4 pt-8">
          <div className="relative">
            <Button onClick={() => setModal("kioskLanguages")} size="large">
              {flagSrc && (
                <div className="left-[3rem] top-[50%] absolute" style={{ transform: "translate(-50%, -50%)" }}>
                  <img src={flagSrc} alt={`${i18n.language} flag`} className="block w-[3rem]" />
                </div>
              )}{" "}
              <div className="mx-auto">{t(`languages.${i18n.language}`)}</div>
            </Button>
          </div>
          <Button onClick={onReturn} size="large">
            {t("goBack")}
          </Button>
          <Button onClick={onBack} size="large">
            {t("newOrder")}
          </Button>
        </div>
      </div>
    </Kiosk>
  );
};

export default KioskNav;
